import * as React from "react";

export const EmptyFilesIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fillRule="evenodd"
    strokeLinejoin="round"
    strokeMiterlimit="2"
    clipRule="evenodd"
    viewBox="0 0 64 64"
  >
    <linearGradient id="lg1">
      <stop offset="0" stopColor="#cadcf0"></stop>
      <stop offset="1" stopColor="#a4bbdb"></stop>
    </linearGradient>
    <linearGradient
      xlinkHref="#lg1"
      id="_Linear1"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="matrix(40 0 0 25.912 12 48.573)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient id="lg2">
      <stop offset="0" stopColor="#a4bbdb"></stop>
      <stop offset="1" stopColor="#8da3be"></stop>
    </linearGradient>
    <linearGradient
      xlinkHref="#lg2"
      id="_Linear2"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="matrix(20.086 0 0 25.912 31.914 48.573)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient id="lg3">
      <stop offset="0" stopColor="#e9f3fc"></stop>
      <stop offset="1" stopColor="#cadcf0"></stop>
    </linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear3"
      x1="0"
      x2="1"
      y1="0"
      y2="0.337"
      gradientTransform="matrix(14.679 14.768 -21.492 8.973 12.133 35.609)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear4"
      x1="0"
      x2="1"
      y1="0"
      y2="0.227"
      gradientTransform="matrix(25.743 1.634 -3.837 17.203 32.081 42.038)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear5"
      x1="0"
      x2="1"
      y1="0"
      y2="-0.619"
      gradientTransform="matrix(20.007 -6.501 5.236 7.762 9.382 31.736)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear6"
      x1="0"
      x2="1"
      y1="0"
      y2="0.429"
      gradientTransform="matrix(15.249 13.945 -20.61 7.651 37.354 21.357)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg1"
      id="_Linear7"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="matrix(40 0 0 13 12 35.606)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg2"
      id="_Linear8"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="scale(16.159)rotate(88.472 .138 1.974)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      id="_Linear9"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="rotate(49.719 3.124 26.068)scale(30.507)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset="0" stopColor="#559aff"></stop>
      <stop offset="1" stopColor="#2e69ef"></stop>
    </linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear18"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="matrix(6.695 0 0 4.448 30.933 4.607)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <linearGradient
      xlinkHref="#lg3"
      id="_Linear19"
      x1="0"
      x2="1"
      y1="0"
      y2="0"
      gradientTransform="matrix(6.695 0 0 -4.448 30.933 10.607)"
      gradientUnits="userSpaceOnUse"
    ></linearGradient>
    <g id="Exp-3.-G">
      <path
        fill="url(#_Linear1)"
        d="M52 35.617H12v18.512a2 2 0 0 0 1.425 1.916l18 5.4a2 2 0 0 0 1.15 0l18-5.4A2 2 0 0 0 52 54.129z"
      ></path>
      <path
        fill="url(#_Linear2)"
        d="M52 35.617H32s-.194 25.912 0 25.912.387-.028.575-.084l18-5.4A2 2 0 0 0 52 54.129z"
      ></path>
      <path
        fill="url(#_Linear3)"
        d="m32 42.106-20-6.489-5.075 7.524a1 1 0 0 0 .52 1.511l17.995 5.846a1 1 0 0 0 1.137-.39z"
      ></path>
      <path
        fill="url(#_Linear4)"
        d="m52 35.617-20 6.489 5.423 8.002a1 1 0 0 0 1.137.39l17.995-5.846a1 1 0 0 0 .52-1.511z"
      ></path>
      <path
        fill="url(#_Linear5)"
        d="M27.159 21.986a1 1 0 0 0-1.136-.388L8.027 27.445a.998.998 0 0 0-.52 1.51L12 35.617l20-6.511z"
      ></path>
      <path
        fill="url(#_Linear6)"
        d="M56.493 28.955a1 1 0 0 0-.52-1.51l-17.996-5.847a1 1 0 0 0-1.136.388L32 29.106l20 6.511z"
      ></path>
      <path
        fill="url(#_Linear7)"
        d="m52 35.617-20-6.511-20 6.511 20 6.489z"
      ></path>
      <path fill="url(#_Linear8)" d="M32 42.106v-13l-20 6.511z"></path>
      <g fill="url(#_Linear9)">
        <path d="M27.982 31.978a9 9 0 0 1-1.124-.868 1 1 0 0 0-1.352 1.473q.614.565 1.382 1.069a1 1 0 0 0 1.094-1.674M24.866 28.906a8.7 8.7 0 0 1-.754-1.213 1 1 0 0 0-1.783.907q.38.748.927 1.492a1 1 0 0 0 1.61-1.186M23.404 24.825q.015-.606.177-1.169a1 1 0 0 0-1.923-.551 6.7 6.7 0 0 0-.254 1.67 1 1 0 0 0 2 .05M24.942 21.485q.387-.358.86-.657a1 1 0 0 0-1.067-1.692 8 8 0 0 0-1.152.882 1 1 0 0 0 1.359 1.467M28.661 19.76a11 11 0 0 1 1.598-.176 1.001 1.001 0 0 0-.085-1.999q-.99.043-1.877.208a1 1 0 0 0 .364 1.967M33.873 19.701q1.279.014 2.384-.085a1 1 0 0 0-.177-1.992q-1.012.09-2.184.077a1 1 0 0 0-.023 2M39.544 19.003c.99-.303 1.826-.691 2.526-1.136a1 1 0 0 0-1.075-1.687 8.3 8.3 0 0 1-2.036.91 1 1 0 0 0 .585 1.913M44.634 15.068a6.2 6.2 0 0 0 .607-3.003 1 1 0 0 0-1.998.093 4.2 4.2 0 0 1-.41 2.04 1.001 1.001 0 0 0 1.801.87M43.997 8.529c-.729-.985-1.718-1.671-2.796-1.892a1.001 1.001 0 0 0-.402 1.96c.622.127 1.17.554 1.591 1.123a1 1 0 1 0 1.607-1.191"></path>
      </g>
      <path
        fill="url(#_Linear18)"
        d="M30.933 6.831c1.082-6.127 10.459-5.731 5 0z"
      ></path>
      <path
        fill="url(#_Linear19)"
        d="M30.933 8.383c1.082 6.126 10.459 5.731 5 0z"
      ></path>
      <path
        fill="url(#_Linear9)"
        d="M30.843 8.617h6.696a1 1 0 0 0 0-2h-6.696a1.001 1.001 0 0 0 0 2"
      ></path>
    </g>
  </svg>
);
